export default {
    placeholder: {
      email: "Please enter email",
      password: "Please enter password"
    }
  }